import { ref, onMounted } from "vue"

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>
}

const elligible = ref(false)
const visible = ref(false)
const showIOSInstructions = ref(false)
let deferredPrompt: BeforeInstallPromptEvent | null = null

window.addEventListener("beforeinstallprompt", (e: Event) => {
  e.preventDefault()
  deferredPrompt = e as BeforeInstallPromptEvent
})

export function usePwaInstall() {

  const isIOS =
    /iphone|ipad|ipod/i.test(window.navigator.userAgent)

  const isMobile = /android|iphone|ipad|ipod|mobile/i.test(window.navigator.userAgent)

  const isInstalled =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.navigator as any).standalone

  function install() {
    if (deferredPrompt) {
      deferredPrompt.prompt()
      deferredPrompt = null
    } else if (isIOS) {
      showIOSInstructions.value = true
      visible.value = true
    }
  }

  function close() {
    visible.value = false
    localStorage.setItem("pwaBannerClosed", "1")
  }

  onMounted(() => {
    // Keep Order
    if (!isMobile) return
    if (isInstalled) return

    elligible.value = true

    if (localStorage.getItem("pwaBannerClosed")) return
    //

    setTimeout(() => {
      visible.value = true
    }, 5000)
  })

  return {
    visible,
    install,
    close,
    elligible,
    showIOSInstructions
  }
}
